import TeamMain from '../views/newOrg/orgHome.vue'
const appRouter = [
  {
    path: '/',
    redirect: '/docFam/docSay/doctorartcile',
    // name: 'index',
    component: () => import('@/views/doctorindex/doctorindex'),
  },
  {
    path: '/showPage',
    name: 'showPage',
    component: () => import('@/views/showPage')
  },
  {
    path: '/org/:orgname',
    name: 'org',
    component: () => import('@/views/newOrg/newIndex')
  },
  {
    path: '/live',
    name: 'live',
    component: () => import('@/views/live/live.vue'),
  },
   {
    path: '/newlive',
    name: 'newlive',
    component: () => import('@/views/live/newlive.vue'),
  },
  {
    path: '/docFam/docSay',
    component: () => import('@/views/doctorindex/doctorindex'),
    children: [{
        path: 'aboutVoice', //医生语音
        component: () => import('@/views/doctorindex/doctorvoice'),
      },
      {
        path: 'doctorartcile', //医生文章
        component: () => import('@/views/doctorindex/doctorartcile'),
      },
      {
        path: 'appearance', //医生风采
        component: () => import('@/views/doctorindex/appearance'),
      },
    ]
  },
  { //文章详情页
    path: '/paragraph/:deviceId',
    component: () => import('@/components/doctorkonwlege/paragraph'),
  },
  { //语音详情页
    path: '/voiceContent',
    component: () => import('@/components/doctorkonwlege/voiceContent'),
  },
  { //个人介绍页
    path: '/introduce',
    component: () => import('@/views/doctorindex/introduce'),
  },
  { //隐私权限
    path: '/right',
    component: () => import('@/views/doctorindex/right'),
  },
  { //团队列表页
    path: '/teamlist',
    component: () => import('@/views/teamlist/teamlist'),
  },
  { //模块文章列表页
    path: '/moduleartilelist',
    component: () => import('@/views/teamlist/moduleartilelist'),
  },
  {
    path: '/print',
    component: () => import('@/views/print/print'),
  },
  { //团队pc端
    path: '/teamcontent',
    redirect: 'orgHome/index',
    component: TeamMain,
    children: [
      {
        path: 'index',
        name: 'index',
        title: '组织官网',
        component: () => import('@/views/newOrg/index'),
      },
      {
        path: 'knowledge', //团队知识
        name:'knowledge',
        component: () => import('@/views/newOrg/knowledge'),
      },
      {
        path: 'artDetail',
        name:'artDetail',
        component: () => import('@/views/newOrg/artDetail'),
      },
      {
        path: 'voiceDetail',
        name: 'voiceDetail',
        component: () => import('@/views/newOrg/voiceDetail'),
      },
      {
        path: 'searchList',
        name: 'searchList',
        component: () => import('@/views/newOrg/searchList'),
      },
      {
        path: 'message',
        name: 'message',
        component: () => import('@/views/newOrg/message'),
      }
    ]
  },

];
export default appRouter;



// WEBPACK FOOTER //
// ./src/router/router.js